/* Base theme script. Progressive enhancement only: every feature below has a working no-script
   fallback (forms post to Shopify, the cart icon links to /cart, details/summary open natively).
   Modules: cart (drawer + section rendering), header (sticky show-on-scroll-up, menu drawer, scrolling
   announcement), motion (reveal on scroll), product (variants, image swatches, gallery, zoom, sticky buy,
   recently viewed),
   collection (filters auto-submit, load more). No dependencies. Motion is feedback only and
   every transition respects prefers-reduced-motion through the stylesheet. */
(function () {
  'use strict';
  var T = window.theme || {};
  /* Every word this script shows comes from window.storeStrings, which layout/theme.liquid renders
     from the locale files, so a store in another language needs no change here. */
  var S = window.storeStrings || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---- money -------------------------------------------------------------------------- */
  function money(cents) {
    var format = T.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var decimals = key.indexOf('no_decimals') > -1 ? 0 : 2;
    var thousands = ',';
    var decimal = '.';
    if (key.indexOf('comma_separator') > -1) { thousands = '.'; decimal = ','; }
    if (key.indexOf('space_separator') > -1) { thousands = ' '; decimal = ','; }
    if (key.indexOf('apostrophe_separator') > -1) { thousands = "'"; decimal = '.'; }
    var parts = n.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return format.replace(/\{\{\s*\w+\s*\}\}/, parts.join(decimal));
  }

  /* ---- cart --------------------------------------------------------------------------- */
  var Cart = {
    drawer: $('[data-drawer]'),
    lastFocus: null,
    sectionIds: function () {
      var ids = ['cart-icon-bubble'];
      if (this.drawer) ids.push('cart-drawer');
      var page = $('[data-cart-section]');
      if (page) ids.push(page.getAttribute('data-cart-section'));
      return ids;
    },
    open: function () {
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      // The lines arrive one after another only while the drawer opens (assets/theme.css, cart-line-in).
      var drawer = this.drawer;
      drawer.classList.add('is-opening');
      clearTimeout(this.openingTimer);
      this.openingTimer = setTimeout(function () { drawer.classList.remove('is-opening'); }, 800);
      this.drawer.removeAttribute('aria-hidden');
      document.body.classList.add('drawer-open');
      var first = $('[data-cart-close]', this.drawer);
      if (first) first.focus();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    bump: function () {
      var count = $('#cart-icon-bubble .cart-count');
      if (!count) return;
      count.classList.remove('is-bumped');
      void count.offsetWidth;
      count.classList.add('is-bumped');
    },
    render: function (sections) {
      if (!sections) return;
      var parser = new DOMParser();
      // A deal celebrates once, at the moment it switches on (assets/theme.css, is-celebrate); per deal, so one line that
      // was already on does not replay when another switches on.
      var unlockedBefore = $$('[data-bundle-bar].is-unlocked').map(function (bar) { return bar.getAttribute('data-deal'); });
      Object.keys(sections).forEach(function (id) {
        var doc = parser.parseFromString(sections[id], 'text/html');
        if (id === 'cart-icon-bubble') {
          var bubble = $('#cart-icon-bubble');
          var fresh = $('#cart-icon-bubble', doc);
          if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
        } else if (id === 'cart-drawer') {
          var target = $('#CartDrawer');
          var next = $('#CartDrawer', doc);
          if (target && next) target.innerHTML = next.innerHTML;
        } else {
          var page = $('[data-cart-section="' + id + '"]');
          var nextPage = $('[data-cart-section]', doc);
          if (page && nextPage) page.innerHTML = nextPage.innerHTML;
        }
      });
      this.bump();
      $$('[data-bundle-bar].is-unlocked').forEach(function (bar) {
        if (unlockedBefore.indexOf(bar.getAttribute('data-deal')) === -1) bar.classList.add('is-celebrate');
      });
      loadComplete();
    },
    request: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    },
    change: function (line, quantity) {
      var self = this;
      var key = line.getAttribute('data-key');
      var error = $('[data-line-error]', line);
      line.classList.add('is-loading');
      var body = { id: key, quantity: quantity, sections: this.sectionIds().join(','), sections_url: window.location.pathname };
      return this.request(T.routes.cart_change, body).then(function (json) {
        if (json.errors || json.status) {
          if (error) error.textContent = json.errors || json.message || json.description || S.cartErrorUpdate;
          line.classList.remove('is-loading');
          return;
        }
        self.render(json.sections);
      }).catch(function () {
        if (error) error.textContent = S.cartErrorUpdateRetry;
        line.classList.remove('is-loading');
      });
    },
    /* Another size for a line (Theme settings, Cart, Change the size in the cart): the line goes to 0 and the new
       variant takes its quantity, plus what another line in the same list already holds of it, in one request. */
    swap: function (line, id) {
      var self = this;
      var qtyInput = $('[data-qty-input]', line);
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var extra = 0;
      $$('[data-line][data-variant="' + id + '"]', line.parentNode).forEach(function (other) {
        if (other === line) return;
        var otherQty = $('[data-qty-input]', other);
        extra += parseInt(otherQty && otherQty.value, 10) || 0;
      });
      var updates = {};
      updates[line.getAttribute('data-key')] = 0;
      updates[id] = qty + extra;
      var error = $('[data-line-error]', line);
      line.classList.add('is-loading');
      return this.request(T.routes.cart_url + '/update.js', { updates: updates, sections: this.sectionIds().join(','), sections_url: window.location.pathname })
        .then(function (json) {
          if (json.status || !json.sections) throw new Error(json.description || json.message || '');
          self.render(json.sections);
        })
        .catch(function (err) {
          if (error) error.textContent = (err && err.message) || S.cartErrorUpdateRetry;
          line.classList.remove('is-loading');
        });
    },
    /* One variant by id (Complete the look): a plain JSON add, then the same render and open as a product form. */
    addId: function (id, button) {
      var self = this;
      if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
      return this.request(T.routes.cart_add + '.js', { items: [{ id: Number(id), quantity: 1 }], sections: this.sectionIds().join(','), sections_url: window.location.pathname })
        .then(function (json) {
          if (json.status) throw new Error(json.description || json.message || S.cartErrorAdd);
          /* A button outside the drawer (a size under a card) stays on the page: show it worked, then reset. */
          if (button) {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-disabled');
            button.classList.add('is-done');
            setTimeout(function () { button.classList.remove('is-done'); }, 1600);
          }
          if (self.drawer) { self.render(json.sections); self.open(); }
          else { window.location.href = T.routes.cart_url; }
        })
        .catch(function () { if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); } });
    },
    add: function (form) {
      var self = this;
      var button = $('[data-add-button]', form) || $('button[type="submit"]', form);
      var error = $('[data-product-error]');
      var fd = new FormData(form);
      fd.append('sections', this.sectionIds().join(','));
      fd.append('sections_url', window.location.pathname);
      if (error) error.textContent = '';
      if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
      return fetch(T.routes.cart_add, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) {
            if (error) error.textContent = json.description || json.message || S.cartErrorAdd;
            return;
          }
          if (button) {
            button.classList.add('is-done');
            setTimeout(function () { button.classList.remove('is-done'); }, 1600);
          }
          if (self.drawer) { self.render(json.sections); self.open(); }
          else { window.location.href = T.routes.cart_url; }
        })
        .catch(function () { if (error) error.textContent = S.errorGeneric; })
        .then(function () { if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); } });
    }
  };

  /* ---- complete the look (Theme settings, Product pages; sections/complementary-products.liquid) ---- */
  /* Every [data-complete] box fetches its recommendations once per URL; the cart boxes carry the cart's variant
     ids in their URL, so an answer never shows something that is already in the cart. The first time a list
     appears its cards slide in; a cached list after a cart change just stands there. */
  var completeCache = {};
  function loadComplete() {
    $$('[data-complete]').forEach(function (box) {
      var url = box.getAttribute('data-url');
      if (!url || box.getAttribute('data-loaded') === url) return;
      box.setAttribute('data-loaded', url);
      var show = function (html, fresh) {
        box.innerHTML = html;
        box.hidden = !html;
        if (fresh && html) {
          box.classList.add('is-new');
          setTimeout(function () { box.classList.remove('is-new'); }, 900);
        }
      };
      if (completeCache[url] !== undefined) { show(completeCache[url], false); return; }
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (text) {
        var list = text ? new DOMParser().parseFromString(text, 'text/html').querySelector('[data-complete-list]') : null;
        completeCache[url] = list ? list.outerHTML : '';
        show(completeCache[url], true);
      }).catch(function () { box.hidden = true; });
    });
  }
  loadComplete();

  /* ---- add from the card: the size picked on this product page is marked on every card ---- */
  /* The letter is the part of the size name before " (" ("M (IT 44)" is M), the same split as the card buttons. */
  (function () {
    var section = $('[data-product][data-size-required]');
    if (!section || !$('[data-quick-add]')) return;
    var index = section.getAttribute('data-size-required');
    function mark() {
      var checked = section.querySelector('input[data-option-index="' + index + '"]:checked');
      var letter = checked ? String(checked.value).split(' (')[0] : '';
      $$('.card-qa__size').forEach(function (b) { b.classList.toggle('is-same', !!letter && b.getAttribute('data-letter') === letter); });
    }
    section.addEventListener('change', mark);
    mark();
  })();

  document.addEventListener('click', function (e) {
    var completeAdd = e.target.closest('[data-complete-add]');
    if (completeAdd) { e.preventDefault(); Cart.addId(completeAdd.getAttribute('data-complete-add'), completeAdd); return; }
    /* Add from the card (snippets/card-quick-add.liquid): one size of the colour on the card. */
    var quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      if (!quickAdd.disabled && !quickAdd.classList.contains('is-loading')) Cart.addId(quickAdd.getAttribute('data-quick-add'), quickAdd);
      return;
    }
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && Cart.drawer) { e.preventDefault(); Cart.open(); return; }
    if (e.target.closest('[data-cart-close]') || (Cart.drawer && e.target === $('[data-drawer-backdrop]', Cart.drawer))) { e.preventDefault(); Cart.close(); return; }
    var qty = e.target.closest('[data-qty-change]');
    if (qty) {
      e.preventDefault();
      var line = qty.closest('[data-line]');
      var input = $('[data-qty-input]', line);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qty.getAttribute('data-qty-change'), 10));
      input.value = next;
      Cart.change(line, next);
      return;
    }
    var remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); Cart.change(remove.closest('[data-line]'), 0); }
  });
  document.addEventListener('change', function (e) {
    var sizeSelect = e.target.closest('[data-line-size]');
    if (sizeSelect) { Cart.swap(sizeSelect.closest('[data-line]'), sizeSelect.value); return; }
    var input = e.target.closest('[data-qty-input]');
    if (input) Cart.change(input.closest('[data-line]'), Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (Cart.drawer && Cart.drawer.classList.contains('is-open')) Cart.close();
      $$('details[open].menu, details[open].search, details[open].facets').forEach(function (d) { d.removeAttribute('open'); });
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    Cart.add(form);
  });

  /* ---- header: sticky show-on-scroll-up, menu drawer, search --------------------------- */
  var header = $('[data-header]');
  var menu = $('[data-menu]');
  if (header && document.body.classList.contains('has-sticky-header')) {
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        var menuOpen = menu && menu.open;
        header.classList.toggle('is-stuck', y > 8);
        if (!menuOpen && !document.body.classList.contains('drawer-open')) {
          if (y > lastY + 6 && y > 120) header.classList.add('is-hidden');
          else if (y < lastY - 6 || y <= 120) header.classList.remove('is-hidden');
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }
  if (menu) {
    menu.addEventListener('toggle', function () {
      document.body.classList.toggle('menu-open', menu.open);
      if (menu.open && header) header.classList.remove('is-hidden');
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-close]') && menu) { menu.removeAttribute('open'); return; }
    $$('details[open].menu, details[open].search, details[open].facets').forEach(function (d) {
      if (e.target === d || !d.contains(e.target)) d.removeAttribute('open');
    });
  });
  $$('details.search').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) { var i = $('input', d); if (i) i.focus(); } });
  });

  /* Scrolling announcement: the pause button stops and restarts it (WCAG 2.2.2); the label follows the state. */
  $$('[data-marquee-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var paused = btn.closest('[data-marquee]').classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', String(paused));
      btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
    });
  });

  /* ---- motion: reveal on scroll (Theme settings, Motion) -------------------------------- */
  /* Only with the setting, IntersectionObserver and no reduced-motion preference. What is already in view is
     marked shown before .js-reveal hides anything, so nothing on screen blinks away; without this script every
     element simply stays visible. */
  (function () {
    if (!document.body.classList.contains('has-motion') || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = $$('[data-reveal]');
    if (!items.length) return;
    var fold = window.innerHeight * 0.92;
    items.forEach(function (el) { if (el.getBoundingClientRect().top < fold) el.classList.add('is-in'); });
    document.documentElement.classList.add('js-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
  })();

  /* ---- product: variants, gallery, zoom, sticky buy, recently viewed ----------------- */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('script[data-variants]', root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $('form[data-product-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var button = form ? $('[data-add-button]', form) : null;
    var buttonLabel = button ? $('.btn__label', button) : null;
    var priceEl = $('[data-price]', root);
    var shipBadge = $('[data-ship-badge]', root);
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
    var gallery = $('[data-gallery]', root);
    var track = gallery ? $('[data-gallery-track]', gallery) : null;
    var slides = track ? $$('[data-media-id]', track) : [];
    var thumbs = gallery ? $$('[data-thumb-for]', gallery) : [];
    var counter = gallery ? $('[data-counter]', gallery) : null;
    var lightbox = $('[data-lightbox]', root);
    var colorIndex = parseInt(root.getAttribute('data-color-index'), 10);
    var sticky = $('[data-sticky-buy]', root);
    var strings = { add: root.getAttribute('data-text-add') || S.addToCart, soldOut: root.getAttribute('data-text-sold-out') || S.soldOut, unavailable: root.getAttribute('data-text-unavailable') || S.unavailable };
    /* Compact variant picker (Theme settings, Product pages): the section carries
       data-size-required with the index of the size option, and the size may stay open until the
       shopper picks one. That state sits on the section as data-needs-size, so product-v2.js and the
       stylesheet read the same thing. Without the attribute sizeIndex is -1 and nothing below changes
       how the page behaves. */
    var sizeIndex = root.hasAttribute('data-size-required') ? parseInt(root.getAttribute('data-size-required'), 10) : -1;
    var sizeGroup = $('[data-size-group]', root);
    var sizePrompt = $('[data-size-prompt]', root);

    function setButtonText(text) { if (buttonLabel) buttonLabel.textContent = text; else if (button) button.textContent = text; }
    function selectedOptions() {
      var out = [];
      $$('[data-option-index]:checked', root).forEach(function (input) { out[parseInt(input.getAttribute('data-option-index'), 10)] = input.value; });
      return out;
    }
    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < options.length; j++) { if (variants[i].o[j] !== options[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    /* Every variant that fits what is chosen so far; an option that is still open fits anything. */
    function fitting(options) {
      return variants.filter(function (v) {
        for (var j = 0; j < options.length; j++) { if (options[j] !== undefined && v.o[j] !== options[j]) return false; }
        return true;
      });
    }
    function visibleSlides() { return slides.filter(function (s) { return !s.hidden; }); }
    function currentSlide() {
      var list = visibleSlides();
      var index = 0;
      var best = Infinity;
      list.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < best) { best = d; index = i; } });
      return { list: list, index: index, slide: list[index] };
    }
    function updateCounter() {
      if (!track) return;
      var c = currentSlide();
      if (counter) counter.textContent = (c.index + 1) + ' / ' + c.list.length;
      thumbs.forEach(function (t) {
        var active = c.slide && t.getAttribute('data-thumb-for') === c.slide.getAttribute('data-media-id');
        t.setAttribute('aria-current', active ? 'true' : 'false');
        if (active && t.scrollIntoView && !t.hidden) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }
    function scrollToMedia(id, instant) {
      var slide = slides.filter(function (s) { return s.getAttribute('data-media-id') === String(id); })[0];
      if (!slide || !track || slide.hidden) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function filterGallery(color) {
      if (isNaN(colorIndex) || !gallery) return;
      var probe = '|' + color + '|';
      slides.forEach(function (s) { var colors = s.getAttribute('data-colors') || ''; s.hidden = colors !== '' && colors.indexOf(probe) === -1; });
      thumbs.forEach(function (t) { var colors = t.getAttribute('data-colors') || ''; t.hidden = colors !== '' && colors.indexOf(probe) === -1; });
    }
    function markAvailability(options) {
      /* Only the visible buttons: the colour select and the hidden mirror radios that back it also
         carry data-option-index, and for those nextElementSibling is not a label. */
      $$('.option__values [data-option-index]', root).forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var test = options.slice();
        test[idx] = input.value;
        var available = variants.some(function (v) {
          if (!v.a) return false;
          for (var j = 0; j < test.length; j++) { if (test[j] !== undefined && v.o[j] !== test[j]) return false; }
          return true;
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !available);
      });
      options.forEach(function (value, i) { var label = $('[data-selected-label="' + i + '"]', root); if (label) label.textContent = value; });
    }
    function thumbSrcFor(mediaId) {
      var thumb = thumbs.filter(function (t) { return t.getAttribute('data-thumb-for') === String(mediaId); })[0];
      var img = thumb && $('img', thumb);
      return img ? img.currentSrc || img.src : null;
    }
    function hideSizePrompt() {
      if (sizeGroup) sizeGroup.classList.remove('is-missing');
      if (sizePrompt) sizePrompt.hidden = true;
    }
    /* Size still open: price and photo follow the colour, the button stays a real button (it asks
       for the size when pressed) and the URL loses its variant, because there is none yet. */
    function showOpenSize(options, initial) {
      var fits = fitting(options);
      var any = fits.some(function (v) { return v.a; });
      var shown = fits.filter(function (v) { return v.a; })[0] || fits[0];
      var sizeLabel = $('[data-selected-label="' + sizeIndex + '"]', root);
      if (sizeLabel) sizeLabel.textContent = '';
      if (shown && priceEl) priceEl.innerHTML = shown.c > shown.p ? '<s>' + money(shown.c) + '</s> ' + money(shown.p) : money(shown.p);
      if (button) { button.disabled = !any; setButtonText(any ? strings.add : strings.soldOut); }
      if (sticky) {
        var sp = $('[data-sticky-price]', sticky); if (sp && shown) sp.textContent = money(shown.p);
        var sv = $('[data-sticky-variant]', sticky); if (sv) sv.textContent = colorIndex > -1 ? (options[colorIndex] || '') : '';
        var st = $('[data-sticky-thumb]', sticky); var src = shown && shown.m ? thumbSrcFor(shown.m) : null; if (st && src) st.src = src;
        var sb = $('button', sticky); if (sb) sb.disabled = !any;
      }
      if (initial) return;
      if (shown && shown.m) scrollToMedia(shown.m);
      if (window.history.replaceState && /[?&]variant=/.test(window.location.search)) {
        var url = new URL(window.location.href);
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url.toString());
      }
    }
    function apply(initial, changed) {
      var options = selectedOptions();
      /* Compact picker: a colour that does not come in the chosen size drops the size instead of
         landing the shopper on a sold out variant, and the size row then shows what that colour does
         have. Only when some size of the new colour is in stock; otherwise sold out is the truth. */
      if (sizeIndex > -1 && changed && parseInt(changed.getAttribute('data-option-index'), 10) !== sizeIndex && options[sizeIndex] !== undefined) {
        var picked = findVariant(options);
        if (!picked || !picked.a) {
          var open = options.slice();
          open[sizeIndex] = undefined;
          if (fitting(open).some(function (v) { return v.a; })) {
            $$('input[data-option-index="' + sizeIndex + '"]:checked', root).forEach(function (input) { input.checked = false; });
            options = selectedOptions();
          }
        }
      }
      var pending = sizeIndex > -1 && options[sizeIndex] === undefined;
      if (sizeIndex > -1) {
        if (pending) root.setAttribute('data-needs-size', '');
        else { root.removeAttribute('data-needs-size'); hideSizePrompt(); }
      }
      var variant = pending ? null : findVariant(options);
      markAvailability(options);
      if (!isNaN(colorIndex)) filterGallery(options[colorIndex]);
      if (pending) {
        showOpenSize(options, initial);
      } else if (variant) {
        if (idInput) { idInput.value = variant.id; idInput.disabled = false; }
        if (priceEl) priceEl.innerHTML = variant.c > variant.p ? '<s>' + money(variant.c) + '</s> ' + money(variant.p) : money(variant.p);
        if (shipBadge) shipBadge.hidden = !(threshold > 0 && variant.p >= threshold);
        if (button) { button.disabled = !variant.a; setButtonText(variant.a ? strings.add : strings.soldOut); }
        if (sticky) {
          var sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = money(variant.p);
          var sv = $('[data-sticky-variant]', sticky); if (sv && variant.t) sv.textContent = variant.t;
          var st = $('[data-sticky-thumb]', sticky); var src = variant.m ? thumbSrcFor(variant.m) : null; if (st && src) st.src = src;
          var sb = $('button', sticky); if (sb) sb.disabled = !variant.a;
        }
        if (variant.m) scrollToMedia(variant.m, initial);
        if (!initial && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        if (idInput) idInput.disabled = true;
        if (button) { button.disabled = true; setButtonText(strings.unavailable); }
      }
      updateCounter();
    }
    root.addEventListener('change', function (e) { var input = e.target.closest('[data-option-index]'); if (input) apply(false, input); });
    if (variants.length) apply(true);

    /* Add to cart with the size still open. product-v2.js answers a tap on the sticky bar with its
       size sheet and cancels this event; the button in the page, and the bar whenever that script is
       missing, get the prompt under the sizes and the focus on the first size that is in stock. */
    function askForSize(source) {
      var ev = null;
      try { ev = new CustomEvent('product:choose-size', { cancelable: true, detail: { source: source } }); } catch (err) { ev = null; }
      if (ev && !root.dispatchEvent(ev)) return;
      if (sizeGroup) sizeGroup.classList.add('is-missing');
      if (sizePrompt) sizePrompt.hidden = false;
      if (sizeGroup && sizeGroup.scrollIntoView) sizeGroup.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      var inputs = sizeGroup ? $$('.option__values input', sizeGroup) : [];
      var first = inputs.filter(function (input) { return !(input.nextElementSibling && input.nextElementSibling.classList.contains('is-unavailable')); })[0] || inputs[0];
      if (first && first.focus) first.focus({ preventScroll: true });
    }
    if (form && sizeIndex > -1) {
      /* On the form itself, so it runs before the document-level handler that adds to cart. */
      form.addEventListener('submit', function (e) {
        if (!root.hasAttribute('data-needs-size')) return;
        e.preventDefault();
        e.stopPropagation();
        askForSize('form');
      });
    }

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { updateCounter(); ticking = false; });
      }, { passive: true });
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb-for]');
        if (thumb) { scrollToMedia(thumb.getAttribute('data-thumb-for')); return; }
        var nav = e.target.closest('[data-gallery-nav]');
        if (nav) {
          var c = currentSlide();
          var next = c.list[Math.min(c.list.length - 1, Math.max(0, c.index + parseInt(nav.getAttribute('data-gallery-nav'), 10)))];
          if (next) track.scrollTo({ left: next.offsetLeft, behavior: 'smooth' });
          return;
        }
        if (lightbox && (e.target.closest('[data-zoom-open]') || e.target.closest('.gallery__slide'))) {
          var slide = e.target.closest('.gallery__slide') || currentSlide().slide;
          var src = slide && slide.getAttribute('data-zoom');
          if (!src || !lightbox.showModal) return;
          var img = $('[data-lightbox-img]', lightbox);
          img.src = src;
          lightbox.showModal();
        }
      });
      if (lightbox) {
        /* A tap or click on the photo zooms in on that spot and the next one zooms back out; the
           zoomed photo pans with a finger or the scroll wheel, and pinch stays the browser's own.
           Baymard: 40% of mobile sites miss tap or pinch zoom on product images while users keep
           trying both. The photo is the 2000px file the lightbox already loads. */
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) { lightbox.close(); return; }
          var img = e.target.closest('[data-lightbox-img]');
          if (img) toggleZoom(img, e);
        });
        lightbox.addEventListener('close', function () { lightbox.classList.remove('is-zoomed'); });
      }
      updateCounter();
    }

    function toggleZoom(img, e) {
      if (lightbox.classList.contains('is-zoomed')) {
        lightbox.classList.remove('is-zoomed');
        lightbox.scrollTop = 0;
        lightbox.scrollLeft = 0;
        return;
      }
      /* Where on the picture itself the tap landed: object-fit: contain leaves empty bands beside or
         above the picture, so the box of the img element is not the picture. */
      var box = img.getBoundingClientRect();
      var ratio = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : box.width / box.height;
      var w = Math.min(box.width, box.height * ratio);
      var h = w / ratio;
      var fx = Math.min(1, Math.max(0, (e.clientX - box.left - (box.width - w) / 2) / w));
      var fy = Math.min(1, Math.max(0, (e.clientY - box.top - (box.height - h) / 2) / h));
      lightbox.classList.add('is-zoomed');
      lightbox.scrollLeft = fx * img.offsetWidth - lightbox.clientWidth / 2;
      lightbox.scrollTop = fy * img.offsetHeight - lightbox.clientHeight / 2;
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-accordion]');
      if (!opener) return;
      var target = document.getElementById(opener.getAttribute('data-open-accordion'));
      if (target) target.open = true;
    });

    if (sticky && button && 'IntersectionObserver' in window) {
      var mq = window.matchMedia('(max-width: 989px)');
      var io = new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        var show = out && mq.matches;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-buy', show);
      }, { threshold: 0 });
      io.observe(button);
      $('button', sticky).addEventListener('click', function () {
        if (root.hasAttribute('data-needs-size')) { askForSize('sticky'); return; }
        if (form.requestSubmit) form.requestSubmit(); else button.click();
      });
    }

    /* recently viewed: last 8 products in this browser only. Eigen sleutel sinds de omschakeling naar het VK (04-11-2026):
       de oude lijst 'theme:recent' bevatte Deense producten in kronen die gearchiveerd zijn; die wordt gewist. */
    var recentEl = $('script[data-recent-item]', root);
    var recentGrid = $('[data-recent-grid]');
    try {
      window.localStorage.removeItem('theme:recent');
      var item = recentEl ? JSON.parse(recentEl.textContent) : null;
      var stored = JSON.parse(window.localStorage.getItem('elv:recent:gb') || '[]');
      var others = stored.filter(function (r) { return item && r.h !== item.h; });
      if (recentGrid && others.length) {
        recentGrid.innerHTML = others.slice(0, 6).map(function (r) {
          return '<article class="product-card"><a href="' + r.u + '"><div class="product-card__media">' + (r.i ? '<img src="' + r.i + '" width="480" height="600" loading="lazy" alt="">' : '') + '</div><h3>' + r.t.replace(/</g, '&lt;') + '</h3><p class="product-card__meta">' + r.p + '</p></a></article>';
        }).join('');
        var section = recentGrid.closest('[data-recent]');
        if (section) section.hidden = false;
      }
      if (item) window.localStorage.setItem('elv:recent:gb', JSON.stringify([item].concat(others).slice(0, 8)));
    } catch (err) { /* storage unavailable: nothing to show */ }
  });

  /* ---- collection: filters and load more --------------------------------------------- */
  $$('form[data-facets]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') { clearTimeout(timer); timer = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 600); return; }
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-load-more]');
    if (!more) return;
    e.preventDefault();
    var grid = $('[data-product-grid]');
    if (!grid) return;
    more.classList.add('is-loading');
    fetch(more.getAttribute('href'), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = $('[data-product-grid]', doc);
        var nextMore = $('[data-load-more]', doc);
        if (nextGrid) Array.prototype.slice.call(nextGrid.children).forEach(function (child) { grid.appendChild(child); });
        if (nextMore) { more.setAttribute('href', nextMore.getAttribute('href')); more.classList.remove('is-loading'); }
        else { more.closest('[data-load-more-wrap]').hidden = true; var pag = $('[data-pagination]'); if (pag) pag.hidden = true; }
        window.history.replaceState({}, '', more.getAttribute('href'));
      })
      .catch(function () { window.location.href = more.getAttribute('href'); });
  });

  /* ---- product cards: photo gallery (Theme settings, Product cards) ------------------ */
  /* Up to three photos per card in a row that snaps (snippets/product-card.liquid). A phone swipes it; a mouse
     picks the photo by where it is over the card, back to the first on leaving. The dots follow the scroll
     position either way. Delegated from the document, so cards added by "load more" work too. The photos after
     the first are lazy; the first touch or hover on a card fetches them, so a swipe does not land on an empty
     frame in a browser that only loads what is on screen. */
  function cardWarm(media) {
    var lazy = media.querySelectorAll('img[loading="lazy"]');
    for (var k = 0; k < lazy.length; k++) lazy[k].loading = 'eager';
  }
  function cardGallery(e) { return e.target.closest ? e.target.closest('[data-card-gallery]') : null; }
  document.addEventListener('pointerdown', function (e) { var m = cardGallery(e); if (m) cardWarm(m); }, { capture: true, passive: true });
  document.addEventListener('pointerover', function (e) { var m = e.pointerType === 'mouse' && cardGallery(e); if (m) cardWarm(m); }, { passive: true });
  function cardDots(track) {
    var w = track.clientWidth;
    if (!w) return;
    var on = Math.round(track.scrollLeft / w);
    var dots = track.parentNode.querySelectorAll('.product-card__dots i');
    for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === on);
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t.nodeType === 1 && t.hasAttribute('data-card-track')) { cardWarm(t); cardDots(t); }
  }, { capture: true, passive: true });
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' || !finePointer.matches) return;
    var media = cardGallery(e);
    var track = media && media.querySelector('[data-card-track]');
    if (!track) return;
    var r = media.getBoundingClientRect();
    var n = track.children.length;
    var i = Math.min(n - 1, Math.max(0, Math.floor((e.clientX - r.left) / r.width * n)));
    var left = i * track.clientWidth;
    if (Math.abs(track.scrollLeft - left) > 1) track.scrollLeft = left;
  }, { passive: true });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var media = cardGallery(e);
    if (!media || media.contains(e.relatedTarget)) return;
    var track = media.querySelector('[data-card-track]');
    if (track) track.scrollLeft = 0;
  });
})();
